// extracted by mini-css-extract-plugin
module.exports = {"enemies":"Enemies_enemies__2gph-","count":"Enemies_count__2vm9U"};